<template>
    <div>
        <div class="top_unit_comment">
            <div v-if="keyName === 'dailyCheck1'" class="top_name_box position_relate">
              <div class="mgb_10" style="display: flex;justify-content: space-between;">
                {{brandStoreName}}
                <div class="check_btn_right_csv" style="display: flex;justify-content: space-between;">
                  <div v-if="!isStoreManager" style="padding: 8px 8px 8px 0px;">
                    アラート通知
                    <input type="checkbox" name="checkbox02" :id="upperTitle" v-model="data.reportCommentAlert.dailyCheck.isAlert" :value="1">
                    <label class="checkbox02" :for="upperTitle"></label>
                  </div>
                  <div>
                    <div class="btn_all_topButton_csv">
                      <a href="#" @click.prevent.stop="allCsvExport()">全帳票一括CSV出力</a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isStaffRegistered">
                  責任者：
                  <select id="historyFilter" :value="staffId" @change="onChange">
                      <option v-for="staff in data.staffList" :key="staff['id']" :value="staff['id']">{{staff['staffName']}}</option>
                  </select>
              </div>
              <p v-if="!isStaffRegistered">責任者：{{managerName}}</p>
            </div>
            <div class="top_center_box pt-4">
                <p v-if="upperTitle !== ''" class="tex_s">{{upperTitle}}</p>
                <p v-if="lowerTitle !== ''" class="tex_l">{{lowerTitle}}</p>
            </div>
            <div v-if="errorText || validationErrorText">
                <Message :validationMessage="alertMessage" />
            </div>
            <div v-if="keyName === 'dailyCheck1'">
                <div class="textarea_unit wd876 mgt_15">
                    <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{errorText}}</p>
                    <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{alertMessage}}</p>
                </div>
                <div v-if="!isLoading" class="textarea_unit wd876 mgt_15">
                    <p class="textarea_name">店舗管理者<span class="mgl_20">最終確認日時 {{storeManagerCommentDatetime}} </span></p>
                    <textarea v-model="data.dailyCheck.comment.storeManager.comment"  :disabled="!isStoreManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                    <p v-if="isStoreManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
                </div>
                <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                    <p class="textarea_name">企業管理者<span class="mgl_20">最終確認日時 {{companyManagerCommentDatetime}} </span>
                      <span v-if="data.dailyCheck.comment.companyManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                      <span v-if="data.dailyCheck.comment.companyManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.dailyCheck.comment.companyManager.staffName}}</span>
                    </p>
                    <textarea v-model="data.dailyCheck.comment.companyManager.comment" :disabled="!isCompanyManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                    <p v-if="isCompanyManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
                </div>
                <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                    <p class="textarea_name">その他管理者<span class="mgl_20">最終確認日時 {{otherManagerCommentDatetime}} </span>
                      <span v-if="data.dailyCheck.comment.otherManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                      <span v-if="data.dailyCheck.comment.otherManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.dailyCheck.comment.otherManager.staffName}}</span>
                    </p>
                    <textarea v-model="data.dailyCheck.comment.otherManager.comment" :disabled="!isOtherManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                    <p v-if="isOtherManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
                </div>
            </div>
        </div>
        <div class="wd876 mgt_25">
            <div  v-for="(button, buttonIndex) in data.dailyCheck[keyName].buttonList" :key="buttonIndex" class="tenpo_check_table">
                <div v-show="button.no === 99 ? false : true">
                    <table class="wd876">
                        <tbody>
                            <tr>
                                <th class="tenpo_bg01">
                                    {{button.name}}
                                    <div class="check_btn_right_csv">
                                    <div class="btn_csv">
                                            <a href="#" @click.prevent.stop="csvExport(keyName,button.no)">CSV出力</a>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tbody>
                        <tr>
                            <td class="text-wrap">
                                {{button.commentList | joinComment(' ')}}
                            </td>
                        </tr>
                    </table>
                    <table v-for="(pageChunk, index) in arrayChunk(nonNull(button.pageList), 1)" :key="index" class="table_sub">
                        <tbody>
                        <th  class="check_th">
                          <div class="check_th_index">
                            <p class="th_index_item text-wrap"><span v-show="pageChunk[0].ngCount > 0" class="red"><i class="fas fa-exclamation"></i></span>{{pageChunk[0].name}}</p>
                            <p class="th_index_name">
                              {{pageChunk[0].staffName}}<br>
                              {{pageChunk[0].updatedTime}}</p>
                          </div>
                        </th>
                        <th class="check_th" style="width: 660px!important;">
                          コメント
                        </th>
                        <tr v-for="(itemIndex, index2) in getItemIndexList(pageChunk)" :key="index2" @click.prevent.stop="validDailyCheck(buttonIndex,index,itemIndex)">
                            <td v-for="(item, index3) in getItems(pageChunk, itemIndex)" class="text-wrap" :key="index3" :class="item.text !== '' && item.result !== 1 ? 'sub_td_red' : ''">
                                <i v-show="item.text !== '' && item.result === 1" class="fas fa-check"></i>{{item.text}}
                            </td>
                            <td v-for="(item, index3) in getItems(pageChunk, itemIndex)" class="text-wrap" :key="index3" style="width: 660px!important;" :class="item.text !== '' && item.result !== 1 ? 'sub_td_red' : ''">
                              {{item.comment}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="check_th_index">
                                    <p class="th_index_item text-wrap">店舗管理者実施</p>
                                    <p class="th_index_name">
                                    </p>
                                </div>
                            </td>

                            <td style="width: 660px!important;">
                                {{pageChunk[0].storeManagerName}} {{pageChunk[0].storeUpdatedTime}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isCsvLoading">
            <pulse-loader class="w-100 text-center" :loading="isCsvLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DailyCheckReport',
        filters: {
            joinComment: function (comment, separator) {
                return comment.map(x => {

                    return  x ? x.page + ':' + x.comment : ''
                }).join(separator)
            },
        },
        props: {
            data: {
                type: Object,
                required: true,
            },
            keyName: {
                type: String,
                default: 'dailyCheck1'
            },
            upperTitle: {
                type: String
            },
            lowerTitle: {
                type: String
            },
            errorText: {
                type: String
            },
            validationErrorText: {
                type: String
            },
            isLoading: {
                type: Boolean
            },
            selectDate:{
                type: String
            },
            staffId: {
                type: Number
            }
        },
        data: function () {
            return {
                title: {
                    lower: null,
                    upper: null,
                },
                storeManagerComment: "",
                companyManagerComment: "",
                otherManagerComment: "",
                showContent: false,
                isCsvLoading:false,
                addFormFlg:true,
                alertMessage:"",
                storeManagerCommentDatetime: '',
                companyManagerCommentDatetime: '',
                otherManagerCommentDatetime: '',
                selectButtonIndex:null,
                selectButtonName:'',
                selectPageIndex:null,
                selectPageId:null,
                selectPageName:'',
                selectItemId:null,
                selectItemIndex:null,
                selectItemName:'',
            }
        },
        created() {
            this.storeManagerComment = this.data.dailyCheck.comment.storeManager.comment;
            this.companyManagerComment = this.data.dailyCheck.comment.companyManager.comment
            this.otherManagerComment = this.data.dailyCheck.comment.otherManager.comment
            this.lastUpdateTimeStore()
            this.lastUpdateTimeCompany()
            this.lastUpdateTimeOther()
        },
        computed: {
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            role: function () {
                return Number(this.$store.getters['manager/manager'].authorityKbn)
            },
            isStoreManager: function () {
                return this.role === 4
            },
            isCompanyManager: function () {
                return this.role === 2
            },
            isOtherManager: function () {
                return this.role === 6
            },
            brandStoreName: function () {
                let brandName = this.$store.getters['brand/name']
                let storeName = this.$store.getters['store/name']

                if (brandName == null) {
                    brandName = ''
                }

                if (storeName == null) {
                    storeName = ''
                }

                return brandName + '・' + storeName
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            isStaffRegistered: function () {
                if(this.role === 4 && this.data.staffList != null){
                    return true
                }
                return false
            },
        },
        methods: {
            nonNull: function (array) {
                return array.filter(x => x !== null)
            },
            arrayChunk : function ([...array], size) {
                return array.reduce((acc, value, index) => index % size ? acc : [...acc, array.slice(index, index + size)], [])
            },
            getItemIndexList: function (pageList) {
                if (! Array.isArray(pageList)) {
                    return []
                }
                const sizeList = pageList.map(x => x.itemList.length)
                const maxSize = Math.max(...sizeList)
                return [...Array(maxSize).keys()]
            },
            getItems: function (pageList, index) {
                if (! Array.isArray(pageList)) {
                    return []
                }

                let itemList = pageList.map(x => {
                    if (x.itemList.length > index) {
                        return x.itemList[index]
                    }
                    return {
                        result: '',
                        text: ''
                    }
                })
                return this.nonNull(itemList)
            },
            checkComent(){

                // コメントの差分をチェックする
                if(this.storeManagerComment !== this.data.dailyCheck.comment.storeManager.comment ||
                    this.companyManagerComment !== this.data.dailyCheck.comment.companyManager.comment ||
                    this.otherManagerComment !== this.data.dailyCheck.comment.otherManager.comment){

                    // 親のコメントフラグを書き換える
                    this.$parent.commentFlg = true;
                }
                else{
                    this.$parent.commentFlg = false;
                }
            },
            async csvExport(key,buttonNo){

                this.addFormFlg = true;
                this.isCsvLoading = true;
                this.alertMessage = "";
                var topButtonNo = null;

                var params = {
                    start_date: this.selectDate,end_date:this.selectDate
                };

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];

                // キーによってTopボタンを判定
                if(key === 'dailyCheck1'){
                    topButtonNo = 1;
                }
                else{
                    topButtonNo = 4;
                }

                // API呼び出し
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/daily/' + topButtonNo + '/' + buttonNo ,{params})
                    .then(response => (this.csvResponseData = response))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        this.addFormFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if (err.customError.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                            if(error.code == 400){
                                this.alertMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isCsvLoading = false);

                if(this.addFormFlg){
                    // CSV出力
                    if(!this.commonDownloadCSV(this.csvResponseData)){
                        this.alertMessage =  "CSVの出力に失敗しました。";
                        this.addFormFlg = false;
                        this.scrollTop();
                    }
                    else{
                        this.showContent = true;
                    }
                }

            },
            closeModel(){
                this.showContent = false;
            },
            scrollTop() {
                window.scrollTo(0, 0);
            },
            formatLastUpdateTime: function (lastUpdateTime) {
                lastUpdateTime = lastUpdateTime.replace(/-/g, '/')
                lastUpdateTime = lastUpdateTime.slice( 0, -3 )
                return lastUpdateTime
            },
            lastUpdateTimeStore: function () {
                if(this.data.dailyCheck.comment.storeManager.commentsDatetime != "") {
                    this.storeManagerCommentDatetime = this.formatLastUpdateTime(this.data.dailyCheck.comment.storeManager.commentsDatetime)
                } else {
                    this.storeManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeCompany: function () {
                if(this.data.dailyCheck.comment.companyManager.commentsDatetime != "") {
                    this.companyManagerCommentDatetime = this.formatLastUpdateTime(this.data.dailyCheck.comment.companyManager.commentsDatetime)
                } else {
                    this.companyManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeOther: function () {
                if(this.data.dailyCheck.comment.otherManager.commentsDatetime != "") {
                    this.otherManagerCommentDatetime = this.formatLastUpdateTime(this.data.dailyCheck.comment.otherManager.commentsDatetime)
                } else {
                    this.otherManagerCommentDatetime = '-'
                }
            },
            updateUserCommentDatetime(){
                if (this.isStoreManager) {
                    this.lastUpdateTimeStore()
                } else if (this.isCompanyManager) {
                    this.lastUpdateTimeCompany()
                } else {
                    this.lastUpdateTimeOther()
                }
            },
            async allCsvExport(){
              this.addFormFlg = true;
              this.isCsvLoading = true;
              this.alertMessage = "";
              var params = {
                date: this.selectDate
              };
              var brandId = this.$store.getters['brand/id'];
              var storeId = this.$store.getters['store/id'];
              var dailyReportCsvResponseData = null;
              var cookingReportCsvResponseData = null;
              var healthCheckReportCsvResponseData = null;
              // API呼び出し
              // 店舗チェック一括CSV
              await this.$axios
                  .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allDaily',{params})
                  .then(response => {
                    dailyReportCsvResponseData = response
                    // 調理チェック一括CSV
                    return this.$axios
                        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allCooking' ,{params})
                  })
                  .then(response => {
                    cookingReportCsvResponseData = response
                    // 健康身だしなみチェックCSV
                    params = {
                      start_date: this.selectDate,end_date:this.selectDate
                    };
                    return this.$axios
                        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allHealth' ,{params})
                  })
                  .then(response => (healthCheckReportCsvResponseData = response))
                  .catch((err) => {
                    let error = {
                      button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                      }}
                    this.addFormFlg = false;
                    if (err.customError) {
                      error = Object.assign(error, err.customError);
                      if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                      }
                      if(error.code == 400){
                        this.alertMessage =  error.message;
                        this.scrollTop();
                      }
                    }
                    if(error.code !== 400){
                      this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                  }).finally(()=> this.isCsvLoading = false);
              if(this.addFormFlg){
                // CSV出力
                if(!this.commonDownloadCSV(dailyReportCsvResponseData) || !this.commonDownloadCSV(cookingReportCsvResponseData) || !this.commonDownloadCSV(healthCheckReportCsvResponseData)){
                  this.alertMessage =  "CSVの出力に失敗しました。";
                  this.addFormFlg = false;
                  this.scrollTop();
                }
                else{
                  this.showContent = true;
                }
              }
            },
            validDailyCheck(buttonIndex,pageIndex,itemIndex){
                if(this.isToday() && this.role == 4 && this.isStaffRegistered){
                    this.addFormFlg = true;
                    this.alertMessage = "";
                    this.selectButtonIndex = buttonIndex;
                    this.selectButtonName = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].name;
                    this.selectPageIndex = pageIndex;
                    this.selectPageId = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].id;
                    this.selectPageName = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].name;
                    this.selectItemIndex = itemIndex;
                    this.selectItemId = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].itemList[this.selectItemIndex].id;
                    this.selectItemName = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].itemList[this.selectItemIndex].text;
                    if(this.selectPageId == null || this.selectItemId == null || this.data.staffList == null) {
                        this.alertMessage = "入力の形式が正しくありません。";
                        this.addFormFlg = false;
                        this.clearSelect()
                        this.scrollTop();
                    } else {
                        var result = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].itemList[this.selectItemIndex].result;
                        if(result === 1) {
                            this.addFormFlg = false;
                        }
                    }
                    if(this.addFormFlg) {
                        this.send();
                    }
                }
            },
            clearSelect(){
                this.selectButtonIndex = null;
                this.selectButtonName = '';
                this.selectPageIndex = null;
                this.selectPageId = null;
                this.selectPageName = '';
                this.selectItemId = null;
                this.selectItemIndex = null;
                this.selectItemName = '';
            },
            async send(){
                this.addFormFlg = true;
                this.isCsvLoading = true;
                this.alertMessage = "";
                //URL生成
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/report/dailyCheck'
                //リクエストデータ生成
                var staff = this.data.staffList.filter(staff => staff['id'] == this.staffId);
                if(staff.length <= 0){
                    this.alertMessage = "入力の形式が正しくありません。";
                    this.addFormFlg = false;
                    this.clearSelect()
                    this.scrollTop();
                    return;
                }
                var staff_id = staff[0]['staffId'];
                var staff_name = staff[0]['staffName'];
                var authority_kbn = this.role;
                var daily_check_page_list = new Array();
                var dailyObj = new Object();
                dailyObj['daily_check_page_id'] = this.selectPageId;
                var daily_check_check = new Array();
                var page = this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex];
                var result = page.itemList[this.selectItemIndex].result;
                if(result !== 1){
                    daily_check_check.push(this.selectItemId);
                }
                dailyObj['daily_check_item_list'] = daily_check_check;
                dailyObj['duplicate_check_datetime'] = page['duplicateCheckDatetime'];
                daily_check_page_list[0] = dailyObj;
                //更新API呼び出し
                await this.$axios
                    .post(url, {staff_id:staff_id,staff_name:staff_name,authority_kbn:authority_kbn,daily_check_page_list:daily_check_page_list})
                    .then(response => {
                        if(response.data.storeUpdatedTime !== null) {
                            this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].itemList[this.selectItemIndex].result = 1;
                            this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].storeUpdatedTime = response.data.storeUpdatedTime;
                            this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].storeManagerName = staff_name;
                            this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].storeManagerId = staff_id;
                            this.data.dailyCheck[this.keyName].buttonList[this.selectButtonIndex].pageList[this.selectPageIndex].duplicateCheckDatetime = response.data.newDuplicateCheckDatetime;
                        }
                    })
                    .catch(err => {
                        let error = {
                            button: {
                                path: {name: 'top', params: { brandPath: this.brandPath }}
                            }}
                        this.addFormFlg = false;
                        if (err.customError) {
                            if (err.customError.code == 400) {
                                this.alertMessage = err.customError.message
                                this.scrollTop();
                                return
                            } else if (err.customError.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            } else if (err.customError.code == 409) {
                                this.alertMessage = err.customError.message
                                this.scrollTop();
                                return
                            }
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isCsvLoading = false);
                // 処理エラーがない場合
                if(this.addFormFlg){
                    this.isCsvLoading = false;
                }
            },
            isToday() {
                const today = new Date();
                const targetDate = new Date(this.selectDate);
                return (
                    today.getFullYear() === targetDate.getFullYear() &&
                    today.getMonth() === targetDate.getMonth() &&
                    today.getDate() === targetDate.getDate()
                );
            },
            onChange(event) {
                const newValue = Number(event.target.value);
                this.$emit('update-staff-id', newValue);
            }
        }
    }
</script>
